// extracted by mini-css-extract-plugin
export var active = "TagsFiltersModal-module--active--5a13f";
export var fadeInAnimation = "TagsFiltersModal-module--fadeInAnimation--a0297";
export var flag = "TagsFiltersModal-module--flag--ccc5a";
export var hidden = "TagsFiltersModal-module--hidden--c2689";
export var showMore = "TagsFiltersModal-module--showMore--df286";
export var tag = "TagsFiltersModal-module--tag--2f564";
export var tagContent = "TagsFiltersModal-module--tagContent--72009";
export var tagsTitle = "TagsFiltersModal-module--tagsTitle--f1095";
export var tagsWrapper = "TagsFiltersModal-module--tagsWrapper--8fc7f";
export var title = "TagsFiltersModal-module--title--34d91";
export var wrapper = "TagsFiltersModal-module--wrapper--ca9e3";